import { GetAllNotificationDTO, GetAllNotificationFiltersDTO, NotificationDTO, NotificationsSianDTO } from "./dto";
import { NotificationServiceImpl } from "./serviceImpl";

export interface NotificationService {
    LoadNotificationsFromFile(data: FormData): Promise<NotificationsSianDTO>
    GetAllNotification(filters: GetAllNotificationFiltersDTO): Promise<GetAllNotificationDTO>
    GetNotificationById(id: string): Promise<NotificationDTO>
}

export function NewNotificationService(): NotificationService {
    return new NotificationServiceImpl()
}